export class ProfileInfo {
    adminFirstName: string;
    adminMiddleName: string;
    adminLastName: string;
    adminPhoneNumber: string;
    adminEmailAddress: string;
}
